import styled from 'styled-components';

const SvgButtonIcon = styled.svg`
  position: absolute;
  left: 20px;
`;

export default SvgButtonIcon;
